module.exports = __webpack_public_path__ + "img/done.0b56f565.svg";